import { render, staticRenderFns } from "./SupplierInvoicesTable.vue?vue&type=template&id=2c8e6734&"
import script from "./SupplierInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports